/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import PropTypes from 'prop-types'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Anchor } from '@nexigendigital/nxui'
import { addAddonToItem, removeAddonFromItem } from 'store/slices/shopSlice'
import { Addon, Pricing } from 'models/shop'
import { useAppDispatch } from 'store/hooks'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    productID: number,
    price: number | undefined,
    addon: Addon,
    isItemAdded: boolean,
    isAddonAdded: boolean,
    pricing: Pricing[]
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function AddonAction({ productID, price, addon, isItemAdded, isAddonAdded, pricing }: Props) {
    const dispatch = useAppDispatch()
    // const isItemAddedToCart = items.some((item) => item.product_id === currentProduct.product_id);
    // const isAddonAddedToItem = items.some((item) => {
    //     if (item.product_id === currentProduct.product_id) {
    //         return item.addons.some((addon) => addon.product_id === id);
    //     }
    //
    //     return false;
    // });

    if (isAddonAdded) {
        return (
            <Anchor
                className={'select'}
                disabled={!isItemAdded}
                color={'primary'}
                onClick={() => dispatch(removeAddonFromItem({
                    product_id: productID,
                    id: addon.id,
                    price: price
                }))}
            >
                Remove
            </Anchor>
        )
    }

    return (
        <Anchor
            className={'select'}
            color={'primary'}
            onClick={() => dispatch(addAddonToItem({
                product_id: productID,
                id: addon.id,
                price: price,
                name: addon.name,
                pricing_list: pricing
            }))}
        >
            Add
        </Anchor>
    )
}

/**********************************************************************************************************
 *   COMPONENT PROPTYPES
 **********************************************************************************************************/
AddonAction.propTypes = {
    productID: PropTypes.number,
    price: PropTypes.string,
    pricing: PropTypes.array,
    isItemAddedToCart: PropTypes.bool,
    isAddonAddedToItem: PropTypes.bool
}
